<template lang='pug'>
  .product(:class="classes")
    roguebuilder-sidebar(ref="dynamicSidebar" :entity="product")
    loading(v-if="status === 'loading'" height="calc(100dvh - var(--header-height, 0px))")
    err404(v-else-if="status === 'error'")
    .cms-layout(v-else-if="isCMSLayout" :block="product.roguebuilder" @click="checkClick($event)")
      RenderBlock(:block="product.roguebuilder")
    .product-page(v-else :class="((product.roguebuilder || {}).props || {}).layout || 'standard'" @click="checkClick($event)")
      .main-container-wide.crumb-container
        .crumbs(v-if="!$rogue.appContext && !isOmQuotePage" :class="breadcrumbColor")
          Breadcrumbs(
            :key="product.productId"
            :category-id="product.primaryCategoryId"
            :links="[{name:product.name}]"
            :breadcrumbColor="breadcrumbColor"
          )
      custom-bumpers(v-if="product.isCustomBumper" :buy-request="buyRequest")
      custom-kneesleeves(v-else-if="product.sku === 'CUSTOMKNEE_NEW' && !buyRequest.loading" :buy-request="buyRequest")
      custom-bar(v-else-if="['CUSTOMBELLA_NEW', 'CUSTOMOHIO_NEW', 'CUSTOMOHIOPOWER_NEW'].includes(product.sku)" :buy-request="buyRequest" :sku="product.sku" @change="checkDynamicMedia")
      nfl-bar(
        v-else-if="['RA0539-NFL-Group'].includes(product.sku)"
        :product="product"
        :buy-request="buyRequest.children[0]"
        @input="checkDynamicMedia()"
      )
      nfl-bumper(v-else-if="product.sku === 'Zeus-NFL-Group'" :product="product" :buy-request="buyRequest")
      quote-product-page(v-else-if="isOmQuotePage" :product="product" :buy-request="buyRequest")
      product-page-v2(v-else-if="shouldUseProductPagev2" :product="product" :buy-request="buyRequest" )
      ProductPage(
        v-else
        :product="product"
        :heroStyle="product.heroStyle"
        :showTabsSlot="showTabs"
        :showMainSlot="showMain"
        :showMicropackageSlot="showMicropackage"
      )
        template(#media)
          //- Specialty products added here by using FeaturedHeroLayout with productSKU
          FeaturedHeroLayout(v-if="['RM-43', 'RF0971-BLACK-MT', 'RA2752-CONFIG'].includes(product.sku) && rbProps.rm43 === true"  :img="product.gallery[0]" :product="product")
          gift-card-media(v-if="product.type === 'giftcard'" :buyRequest="buyRequest")
        template(#title="slotProps")
          ProductTitle(:product="product" :show-h1="slotProps.showH1")
        template(#tabs)
          RenderBlock(:block="slots.tabs" :product="product" v-if="showTabs" :selectedSimple="selectedSimple")
        template(#rhpa)
          Price(v-if="rbProps.customRHPA && rbProps.displayPrice" :product="product" theme="rhpa")
          .divider(v-if="rbProps.customRHPA && rbProps.displayPrice")
          RenderBlock(
            v-if="rbProps.customRHPA"
            :block="slots.rhpa"
            :product="product"
          )
          Rhpa(
            v-else-if="buyRequest && buyRequest.productId"
            :buy-request="buyRequest"
            @change="checkDynamicMedia"
            :pdpProductId="id"
            :customBadge="rbProps.customBadge"
            :customBadgePosition="rbProps.customBadgePosition"
            :isCartShipsFreeProduct="isCartShipsFreeProduct"
          )
            template(#rhpaTop)
              .cart-ships-free-badge(v-if="isCartShipsFreeProduct")
                StaticImage.img(src="/cms/shipping%20promotions/Free-Cart-Icon_jgqo4q_ju2okk.svg" alt=""
                  :width="100"
                  :height="100"
                  :background="`#ffffff`"
                  style="width: 65px" ssr contain)
                .cart-ships-free-content
                  h5 {{ __('Entire Order Ships Free') }}
                  div
                    | {{ __('This Item Qualifies Your Entire Cart To Ship Free. ') }}
                    rogue-link.link(to="/shipping-promotions") {{ __("See Details") }}
              RenderBlock(:block="slots.aboveRhpa" :product="product" :selectedSimple="selectedSimple")
            template(#rhpaCustomBadge)
              RenderBlock(
                v-if="rbProps.customBadge"
                :block="slots.rhpaCustomBadge"
                :product="product"
              )
          loading(v-else)
        template(#hero)
          RenderBlock(:block="slots.hero" :product="product")
        template(#flexible)
          .three-free-badge(v-if="(product.attributes || {}).free_3")
            StaticImage.img(src="/cms/shipping%20promotions/3ships-100x100_r7aikc.png" alt=""
              :width="100"
              :height="100"
              :background="`#ffffff`"
              style="width: 100px" ssr contain)
            .three-free-content
              h4 {{ __('3 Ships Free Item') }}
              div {{ __('Buy 3 or More Items Marked "3 Ships Free" And They All Ship for Free') }}
          .five-for-five-badge(v-if="isFiveForFive && $rogue.featureFlags.isOn('fiveforfive_enabled')")
            StaticImage.img(:src="fiveForFiveRoundIcon" alt=""
              :width="100"
              :height="100"
              :background="`#ffffff`"
              style="width: 100px" ssr contain)
            .five-for-five-content
              h4 {{ __(`5 Items Ship for ${$rogue.currency(5, { hideFractionalUnits: true })}`) }}
              div {{ __(`Buy 5 or More Items Marked "5 Ship for ${$rogue.currency(5, { hideFractionalUnits: true })}" & They All Ship for ${$rogue.currency(5, { hideFractionalUnits: true })}`) }}
              p.small(v-if="$rogue.site.code === 'USA'") {{ __('CONT. US 48 ONLY') }}
              p.small(v-else-if="['GBR', 'EUR'].includes($rogue.site.code)") {{ __('GRAY ZONE ONLY') }}
          RogueButton.scroll-to-micropackage(
            color="flat"
            width="full"
            @click="$refs.micropackage.$el.scrollIntoView({block: 'center'})"
            v-if="showMicropackage && product.attributes.rogue_micropackage_enable_scroll"
          ) {{__('View Frequently Bought Together')}}
          RenderBlock(:block="slots.flexible" :product="product" :selectedSimple="selectedSimple")
        template(#main)
          RenderBlock(:block="slots.main"  v-if="showMain" :product="product" :rhpaConfig="rhpaConfig" :selectedSimple="selectedSimple")
        template(#full)
          RenderBlock(:block="slots.full" :product="product" :rhpaConfig="rhpaConfig"  :selectedSimple="selectedSimple")
        template(#micropackage)
          micropackage(:buyRequest="buyRequest" v-if="showMicropackage" ref="micropackage")
        template(#bottom)
          product-bottom(:product="product")
</template>

<script>
import { getItemSku, getBundleVariationImageCloudinaryPath } from '@rogue/universal'
import { getCloudinaryUrl } from 'sisu/js/helpers'
import { defineAsyncComponent, nextTick } from 'vue'
import Rhpa from '../../components/rhpa/rhpa.vue'
import RoguebuilderSidebar from '../../components/roguebuilder-sidebar.vue'
import { viewProgram } from '../account/subroutes/programming/view-program'
import { MMS_GROUPED_SKU } from './rackbuilder/utils/mms-utils/mms-constants'
import { MS_GROUPED_SKU } from './rackbuilder/utils/ms-utils/ms-constants'
import { isEnabledCustomProduct } from '@/js/customProducts/registry'
import { messages } from '@/js/app-bridge/messages'
import productStars from '@/js/components/product-stars.vue'
import ProductTitle from '@/js/components/rhpa/product-title.vue'
import {
  createBuyRequest,
  getBuyRequestMeta,
  getSimpleForBuyRequest,
  recreateBundleBuyRequest,
} from '@/js/helpers/buy-request'
import metadata from '@/js/helpers/metadata'
import { getLDJsonForProduct } from '@/js/pages/product/ldjson'
import ProductBottom from '@/js/pages/product/product-bottom.vue'
import ProductPageV2 from '@/js/pages/product/product-page-v2.vue'
import { useCategoryStore } from '@/js/stores/categoryStore'
import { useProductStore } from '@/js/stores/productStore'
import { usePromoStore } from '@/js/stores/promoStore'
import { useReviewsStore } from '@/js/stores/reviewsStore'

export default {
  name: 'PageProduct',

  components: {
    ProductPageV2,
    QuoteProductPage      : defineAsyncComponent(() => import('./quote-product-page.vue')),
    RoguebuilderSidebar,
    ProductTitle,
    CustomBar             : defineAsyncComponent(() => import(/* webpackChunkName: "customBar"*/ './custom-bar/custom-bar.vue')),
    CustomKneesleeves     : defineAsyncComponent(() => import(/* webpackChunkName: "customKnee" */'./custom/custom-kneesleeves.vue')),
    CustomBumpers         : defineAsyncComponent(() => import(/* webpackChunkName: "customBumper" */'./custom/custom-bumpers.vue')),
    NflBar                : defineAsyncComponent(() => import(/* webpackChunkName: "nfl" */'./custom-bar/nfl.vue')),
    NflBumper             : defineAsyncComponent(() => import(/* webpackChunkName: "nflBumper" */ '@/js/pages/product/nfl_bumper/nfl-bumper.vue')),
    Micropackage          : defineAsyncComponent(() => import(/* webpackChunkName: "micropackage" */'./components/micropackage.vue')),
    GiftcardBalanceButton : defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */'./components/giftcard-balance-button.vue')),
    GiftcardBalanceCheck  : defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */'./components/giftcard-balance-check.vue')),
    GiftCardMedia         : defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */'./components/giftcard-media.vue')),
    FeaturedHeroLayout    : defineAsyncComponent(() => import('./components/featured-hero-layout.vue')),
    productStars,
    Rhpa,
    ProductBottom,
  },

  provide() {
    return {
      updateBuyRequest: this.updateBuyRequest,
    }
  },

  inject: {
    isOmQuotePage: {
      from    : 'IS_OM_QUOTE_PAGE',
      default : false,
    },
  },

  props: {
    productId: {
      type     : Number,
      required : false,
    },
    layout: { type: String },
  },

  emits: ['loadError'],

  setup() {
    const categoryStore = useCategoryStore()
    const productStore = useProductStore()
    const promoStore = usePromoStore()
    const reviewsStore = useReviewsStore()

    return {
      categoryStore,
      productStore,
      promoStore,
      reviewsStore,
    }
  },

  data: () => ({
    status        : 'loading',
    loading       : true,
    isFiveForFive : false,
    buyRequest    : null,
    metadata      : null,
    ldJSON        : null,
    rhpaConfig    : null,
    recipeData    : null,
  }),

  head() {
    const { meta_title: metaTitle, meta_description: metaDescription } = this.product.attributes || {}
    const title = metaTitle ? this.__(metaTitle, undefined, this.product.sku) : this.product.name
    let description = (metaDescription || this.product.description || '')

    if (description) {
      description = this.__(description, undefined, this.product.sku)
      description = description.replace(/<[^>]*>/gi, '')
    }

    let path = this.$route.path
    // If this is a sub-url for a product (which shouldn't really exist) we want to at least canonicalize it back to the real url
    // e.g. /new-gear/rogue-echo-bike should canonicalize back to /rogue-echo-bike
    if (path.split('/').length > 2 && path !== this.product.url) {
      path = this.product.url
    }

    this.metadata = {
      title,
      description,
      url   : `${this.$rogue.localizedBaseURL}${path}`,
      type  : 'product',
      image : getCloudinaryUrl(this.product.image, 1600, undefined, '#ffffff'),
    }

    if (this.product?.attributes?.rogue_hide_in_sitemap === true || this.product?.attributes?.rogue_seo_noindex === true) {
      this.metadata.robots = 'none'
    } else {
      this.metadata.robots = 'all'
    }

    if (this.ldJSON) {
      this.metadata.script = [{
        type      : 'application/ld+json',
        key       : 'product-ld-json',
        innerHTML : JSON.stringify(this.ldJSON),
      }]
    }

    return metadata(this.metadata, this.$rogue)
  },

  computed: {
    products() {
      return this.productStore.products
    },
    reviews() {
      return this.reviewsStore.reviews
    },
    summaries() {
      return this.reviewsStore.summaries
    },
    categories() {
      return this.categoryStore.categories
    },
    activePromos() {
      return this.promoStore.activePromos
    },
    lastUpdate() {
      return this.promoStore.lastUpdate
    },
    id() {
      return this.productId || this.$route.meta.id
    },

    shouldUseProductPagev2() {
      // MMS/MS SKUs always have rbProps.rackbuilder so guard against routing to v2 when the flag is off.
      if (this.product.sku === MMS_GROUPED_SKU) {
        return this.isMonsterMassStorage
      }

      if (this.product.sku === MS_GROUPED_SKU) {
        return this.isMassStorage
      }

      return this.rbProps.pageType === 'basic' || (this.rbProps.rackbuilder || {}).area === 'main'
    },

    selectedSimple() {
      const simple = getSimpleForBuyRequest(this.buyRequest, this.$rogue)

      return simple
    },

    classes() {
      return {
        'full-bleed-full'                              : this.rbProps.fullBleed,
        [`product-${this.product.sku?.toLowerCase()}`] : true,
      }
    },

    showMain() {
      return !!(this.slots.main || []).length
    },

    showMicropackage() {
      return !!(this.product.micropackageIds?.length && this.buyRequest && !this.buyRequest.loading)
    },

    showTabs() {
      return !!(this.slots.tabs || []).length
    },

    slots() {
      return ((this.product.roguebuilder || {}).slots || {})
    },

    product() {
      return this.products[this.id] || {}
    },

    isCMSLayout() {
      return this.product.roguebuilder?.name === 'CMS'
    },

    rbProps() {
      return this.product.roguebuilder?.props || {}
    },

    breadcrumbColor() {
      const props = this.rbProps

      if (props?.breadcrumbColor) {
        return props?.breadcrumbColor
      }

      if (props?.layout === 'hero') {
        return 'light'
      }

      return 'dark'
    },
    isCartShipsFreeProduct() {
      return (this.selectedSimple?.attributes?.shipperhq_shipping_group || []).includes('FREE_CART')
    },
    fiveForFiveRoundIcon() {
      switch (this.$rogue.site.code) {
        case 'EUR':
          return '/UI/matte_black/5for5-Round-Icon-Euro-Black.svg'
        case 'GBR':
          return '/UI/matte_black/5for5-Round-Icon-Pound-Black.svg'
        default:
          return '/UI/matte_black/5for5-Round-Icon-US-Black.svg'
      }
    },
    isMonsterMassStorage() {
      return MMS_GROUPED_SKU.includes(this.product.sku) && this.$rogue.featureFlags.isOn('enable-monster-mass-storage')
    },
    isTheCave() {
      return isEnabledCustomProduct(this.$rogue, 'cave', this.product)
    },
    productUsesRID() {
      return this.isMonsterMassStorage || this.isTheCave || this.isMassStorage || this.isSlingerX || this.isHybridRig
    },
    isMassStorage() {
      return MS_GROUPED_SKU.includes(this.product.sku) && this.$rogue.featureFlags.isOn('enable-mass-storage')
    },
    isSlingerX() {
      return isEnabledCustomProduct(this.$rogue, 'slinger-x', this.product)
    },
    isHybridRig() {
      return isEnabledCustomProduct(this.$rogue, 'hybrid-rig', this.product)
    },
  },

  watch: {
    // If this product goes on promo, we need to recalculate the ldjson
    async lastUpdate() {
      try {
        const simple = getSimpleForBuyRequest(this.buyRequest, this.$rogue)
        if (this.activePromos[simple?.productId]) {
          await this.updateLDJSON()
        }
      } catch (error) {
        this.$rogue.log.error(`lastUpdate failed to update the LDJSON ${this.$route.fullPath}: ${error.message}`, error)
      }
    },

    '$route.query.rid': {
      immediate: true,
      async handler(newRid, oldRid) {
        if (newRid !== oldRid && this.productUsesRID) {
          if (!newRid) {
            // rid was removed — reset recipe state and reload the default product configuration.
            // The id watcher may not fire if the product didn't change, so we must call load() here.
            this.recipeData = null
            this.load()

            return
          }
          try {
            // Set buyRequest to null to trigger reactivity
            this.buyRequest = null

            const response = await this.$rogue.fetch(`/svc_zeus/product/configs/${newRid}`)

            // SSR leaves a recipe rooted at another product to load(); on the client, dropping the rid lets the removal branch above rebuild the default.
            if (Number(response.buyRequest?.productId) !== this.id) {
              if (!this.$rogue.ssr) {
                this.$router.replace({ query: { ...this.$route.query, rid: undefined } })
              }

              return
            }

            this.recipeData = response

            nextTick(() => {
              this.buyRequest = response.buyRequest
            })
          } catch (error) {
            this.$rogue.log.error(`Failed to load recipe for rid=${newRid}: ${error.message}`, error)
          }
        }
      },
    },

    id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.recipeData = null
        this.load()
      }
      const galleryBottom = this.$el.querySelector('.grid-media')?.getBoundingClientRect().bottom
      if (galleryBottom < 100) {
        this.$el.scrollIntoView({ block: 'start' })
      }
    },
    buyRequest: {
      deep: true,
      handler() {
        if (this.status === 'loaded') {
          this.updateMeta()
        }
      },
    },
    '$route.query.b': {
      handler() {
        this.load()
      },
    },
  },

  created() {
    if (this.products[this.id]) {
      this.loading = false
      this.status = 'loaded'
    }
    if (!this.$rogue.ssr) {
      this.load()
    }
  },

  async serverPrefetch() {
    await this.load()
  },

  mounted() {
    if (this.$rogue.appContext) {
      this.$emitToApp(messages.DOM_LOADED, {})
    }

    if (this.$route.query.showInstr) {
      this.viewInstructionsPdf()
    }
  },

  beforeUnmount() {
    this.resetDynamicMedia()
  },

  methods: {
    async viewInstructionsPdf() {
      const instructionsSku = this.$route.query.showInstr
      const productWithInstructions = await this.productStore.load(instructionsSku, this.$rogue)
      const instructionsUrl = productWithInstructions?.attributes?.instructions_gallery

      if (instructionsUrl) {
        // Using viewProgram that is used also for programming products, can update this to be more universal later if needed
        viewProgram(this.$rogue, instructionsUrl, { name: productWithInstructions.name, thumbnail: { src: '' } })
        this.$rogue.track.track({ type: 'custom', event: 'Instructions PDF', data: { product: { name: this.product.name, id: this.product.productId, sku: productWithInstructions.sku, instructionsUrl } } })
      }
    },
    updateBuyRequest(newVal) {
      this.buyRequest = newVal // replaces main buyRequest with updates
    },
    checkClick(e) {
      this.$refs.dynamicSidebar?.checkClick(e)
    },
    updateMeta() {
      const val = this.buyRequest
      try {
        if (!val || val.loading) {
          this.rhpaConfig = null
        } else {
          const meta = getBuyRequestMeta(val, this.$rogue)
          Object.entries(meta.configuration || {}).forEach(([key, value]) => meta[key] = value)

          this.rhpaConfig = meta
        }
      } catch (e) {
        this.$rogue.log.warn('Error creating rhpaConfig', e)
      }
      this.isFiveForFive = this.rhpaConfig?.flags?.fiveForFive || false
    },
    async updateLDJSON() {
      if (this.status === 'error' || this.status === 'loading') {
        return
      }
      try {
        this.ldJSON = await getLDJsonForProduct(this.buyRequest, this.$rogue)
      } catch (e) {
        this.$rogue.log.warn('Error creating LDJson', e)
      }
    },
    resetDynamicMedia() {
      Object.values(this.dynamicMedia || {})
        .filter(img => img.originalLink)
        .forEach(img => img.link = img.originalLink)

      this.dynamicMedia = null
    },

    async load() {
      if (!this.id) {
        this.$rogue.log.error(`Mounted product.vue without a product ID for ${this.$route.fullPath}`)
        this.buyRequest = null
        this.status = 'error'

        return
      }



      /**
       * This action will try to load all of the products necessary to create the RHPA for this PDP.
       *
       * If all of the children are already loaded, it will *synchronously* return TRUE - meaning we do not have to
       * "await" for the promise to resolve (make network requests)
       *
       * If it returns a promise, that means we need to show a RHPA loading spinner while we wait for the children to load
       * @type {Promise<any>, Boolean}
       */

      // If the product itself is not loaded yet, we need to show a spinner on the whole page - since we dont know the title
      // or category of the product yet
      if (!this.products[this.id]) {
        this.status = 'loading'

        await this.productStore.loadAllChildren(this.id, this.$rogue)
      }

      // For rid-based products (MMS/Cave), let the rid watcher manage buyRequest.
      // Fallback fetch handles cold start where the watcher hasn't fired yet.
      if (this.$route.query.rid && this.productUsesRID) {
        // Read up front: the rid watcher can drop the param from the route while the fetch below is in flight.
        const rid = this.$route.query.rid
        let recipeIsForAnotherProduct = false

        if (!this.recipeData) {
          try {
            const response = await this.$rogue.fetch(`/svc_zeus/product/configs/${rid}`)
            recipeIsForAnotherProduct = Number(response.buyRequest?.productId) !== this.id

            if (recipeIsForAnotherProduct) {
              this.$rogue.log.warn(`Ignoring rid=${rid}: recipe is for product ${response.buyRequest?.productId}, not ${this.id}`)
            } else {
              this.recipeData = response
              this.buyRequest = response.buyRequest
              await this.updateLDJSON()
              this.buyRequest = null
              nextTick(() => {
                this.buyRequest = response.buyRequest
              })
            }
          } catch (error) {
            this.$rogue.log.error(`Failed to load recipe for rid=${this.$route.query.rid}: ${error.message}`, error)
          }
        } else {
          await this.updateLDJSON()
        }

        // Recipes are saved from the page's own buy request, so one rooted elsewhere is a bad link (e.g. an MMS rid on the MS page).
        if (!recipeIsForAnotherProduct) {
          return
        }

        // The rid watcher's removal branch rebuilds the default once the param is gone; SSR can't change the URL, so it renders the default below.
        if (!this.$rogue.ssr) {
          this.$router.replace({ query: { ...this.$route.query, rid: undefined } })

          return
        }
      }

      if (this.$rogue.appContext) {
        const data = {
          url       : `${this.$rogue.localizedBaseURL}${this.$route.fullPath}`,
          type      : 'catalog/product',
          title     : this.product.name,
          productId : this.id,
        }

        this.$emitToApp(messages.PAGE_OPENED, data)
      }

      this.$rogue.log.debug(`Loaded ${this.id} ${this.product.name} ${this.product.sku} ${this.product.productId}`)

      // Once the main product has loaded, we actually can show the main PDP, even if all of the children are not loaded yet.
      // Roguebuilder and Gear Specs are associated with the parent product
      this.status = 'loaded'
      if (!this.$rogue.ssr) {
        /**
         * If we are going to show the main PDP before the children are loaded, we need to tell the RHPA that it is not ready yet.
         * We can do that by creating a "fake" buy request with `loading: true`, to tell the RHPA to show a spinner.
         * Once the children are loaded, we will replace this with a "real" buy request
         *
         * NOTE - if we are loading the page from an SSR, we should NOT get to this point. The SSR should *always* provide
         * enough data for the hydration to be able to create a buy request synchronously. Otherwise, the RHPA DOM
         * from the SSR will be for the fully loaded RHPA, but the client side render will try to show a spinner, and cause
         * a hydration error
         */
        this.buyRequest = {
          loading       : true,
          children      : [],
          configuration : [],
          options       : {},
          productId     : this.id,
        }
      }

      // If we weren't able to load the parent product by this point, it means we have an error situation
      if (!this.product.productId) {
        if (!this.$rogue.ssr) {
          // For non-SSR instances, it is possible we get routed here without a productId because it is a redirect.
          // In this case, re-run the route service to see if it has a redirect for us.
          // SSR instances of this will handle redirects within the SSR service.
          this.$emit('loadError')
        } else if (this.$rogue.ssrContext?.renderData) {
          this.status = 'error'
          this.$rogue.ssrContext.renderData.status = 404
        }

        return
      }

      if (this.$rogue.i18n.enabled) {
        const loadTranslations = this.$rogue.i18n.loadNamespace(this.product.sku)
        if (loadTranslations) {
          this.status = 'loading'
          await loadTranslations
          this.status = 'loaded'
        }
      }

      // If the product has a CMS layout the only thing needed is to render that CMS page
      if (this.isCMSLayout) {
        return
      }

      try {
        if (!this.productStore.allChildrenLoaded(this.id)) {
          /**
           * If the "Load Children Promise" we created earlier is anything other than *true*, we will need to wait
           * for it to load before trying to create the "real" buy request.
           *
           * If this is an initial hydration coming from an SSR, we will have a hydration error at this point.
           */

          await this.productStore.loadAllChildren(this.id, this.$rogue)
        }

        // When a bundle product loads, not all products referenced by its options are guaranteed to be fetched.
        // Load any missing option products now so createBuyRequest has everything it needs.
        if (this.product?.type === 'bundle') {
          const optionProductIds = [...new Set(
            this.product.bundleOptions?.flatMap(opt => opt.values.map(v => v.productId)) ?? []
          )].filter(id => !this.productStore.allChildrenLoaded(id))

          if (optionProductIds.length) {
            await Promise.all(optionProductIds.map(id => this.productStore.loadAllChildren(id, this.$rogue)))
          }
        }

        // If there is a sku present grab it
        // We're seeing requests that have multiple sku params causing this to be an array.
        let childId
        const qsSku = this.$route.query.sku
        if (qsSku && typeof qsSku === 'string') {
          const toFind = qsSku.toLowerCase()
          childId = Object.values(this.products).find(product => product.sku.toLowerCase() === toFind)?.productId

          if (!childId) {
            // Try to match one more time
            // Magento converts periods to - in the URL key for simple products
            // We need to be able to handle both scenarios by replacing the last - in the SKU
            const alternateSku = qsSku.replace(/-(?=[^-]*$)/, '.')
            childId = Object.values(this.products).find(product => product.sku.toLowerCase() === alternateSku.toLowerCase())?.productId
          }
        }

        // Create the real buy request
        const buyRequest = createBuyRequest(this.product, this.$rogue, childId)

        if (this.$route.query.b) {
          try {
            const productIds = this.$route.query.b.split('-').map(id => Number(id))
            recreateBundleBuyRequest(buyRequest, this.$rogue, productIds)
          } catch (e) {
            this.$rogue.log.warn('Error recreating bundle', e)
          }
        }

        this.buyRequest = buyRequest

        // Dynamic Media means the currently selected child (for configurables) can change the media area - like
        // when selecting a Blue attribute causes the rack to show a blue image
        this.resetDynamicMedia()
        this.checkDynamicMedia(this.buyRequest)
      } catch (e) {
        this.$rogue.log.error(`Could not create buy request for ${this.id}`, e)
        this.status = 'error'
      }

      if (this.status !== 'error') {
        this.categoryStore.load(this.product.primaryCategoryId, this.$rogue)
          .then(() => this.$rogue.track.track({ type: 'productDetailView', product: this.product, items: [this.buyRequest] }))
          .catch((err) => this.$rogue.log.warn('Error loading category or tracking product view', err))

        const sku = this.product.sku.toUpperCase()

        try {
          if (!this.summaries[sku] || !this.reviews[sku]?.length) {
            await Promise.all([
              this.reviewsStore.loadFirstEightReviews(this.product.sku, this.$rogue),
              this.reviewsStore.loadSummaries([this.product.sku], this.$rogue),
            ])
          }

          // Check if the current product is on an active hot deal. If so, SSR should wait for the hot deal json to load
          // so that the ld-json can show the correct value.
          if (this.$rogue.ssr && !this.lastUpdate) {
            // const simpleProduct = getSimpleForBuyRequest(this.buyRequest, this.$rogue)
            // if (simpleProduct?.attributes?.rogue_promo_active || simpleProduct?.attributes?.rogue_promo_qty_enable) {
            await this.promoStore.refresh(this.$rogue)
            // }
          }

          await this.updateLDJSON()
        } catch (e) {
          this.$rogue.log.error(`Invalid LDJson for ${this.product.productId}: ${e.message}`, e)
        }

        try {
          this.updateMeta()
        } catch (e) {
          this.$rogue.log.error(`Error updating metadata for product ${this.product.productId}: ${e.message}`, e)
        }
      }
    },

    checkDynamicMedia(buyRequest = this.buyRequest) {
      if (!buyRequest?.productId) {
        return
      }

      if (!this.dynamicMedia) {
        this.dynamicMedia = {}
        this.product.gallery?.forEach(m => {
          const tag = m.label?.find(l => l.indexOf('dynamic_') === 0)
          if (tag) {
            m.originalLink = m.link
            this.dynamicMedia[tag] = m
          }
        })
      }

      if (this.products[this.product?.childrenIds?.[0]]?.attributes?.pdp_variation_header_path) {
        if (this.$rogue.ssr && this.product.gallery.length > 0) {
          this.product.gallery.unshift({
            link  : this.product.gallery[0].link,
            alt   : this.product.name,
            type  : 'image',
            label : ['dyn_bundle'],
          })

          return
        }
        // This bundle product has a dynamic gallery based on bundle option selections
        const bundleBuyRequest = this.buyRequest.type === 'group'
          ? this.buyRequest.children.find((ch) => ch.type === 'bundle')
          : this.buyRequest

        const imgUrl = getBundleVariationImageCloudinaryPath(bundleBuyRequest, this.$rogue, 'pdp_variation_header_path', 'pdp_variation_header_pattern')

        const dynBundleHeader = this.product.gallery.find(g => g.label.includes('dyn_bundle'))

        if (!dynBundleHeader) {
          this.product.gallery.unshift({
            link  : imgUrl,
            alt   : this.product.name,
            type  : 'image',
            label : ['dyn_bundle'],
          })
        } else {
          dynBundleHeader.link = imgUrl
        }

        return
      }

      if (!Object.keys(this.dynamicMedia).length || !this.product) {
        return
      }

      const sku = getItemSku(buyRequest.type === 'group' ? buyRequest.children[0] : buyRequest, this.$rogue, this.$rogue.site.defaultStoreId)

      const product = this.products[buyRequest.productId]

      const simple = getSimpleForBuyRequest(buyRequest, this.$rogue)

      const skuMap = [{ old: 'RA0539', new: 'RA2889' }, { old: 'RA0584', new: 'RA2894' }, { old: 'RA0586', new: 'RA2895' }]

      product.gallery.filter(img => Boolean(img.root)).forEach(img => {
        let imgSku = img.wOpts ? sku : simple.sku

        const isZeusSku = sku.endsWith('-CST')

        if (isZeusSku) {
          // base SKU for the Ohio, Bella, and Power Bars were updated. Need to map the new skus to the old skus so we do not break the images for Zeus
          const newSku = skuMap.find(s => imgSku.indexOf(s.new) > -1)

          if (newSku) {
            imgSku = imgSku.replace(newSku.new, newSku.old)
          }
        }

        img.link = `${img.root}${imgSku}-DYN.png`
      })

      if (product?.type === 'simple') {
        product.gallery?.forEach(item => {
          item.label?.filter(l => this.dynamicMedia[l]).forEach(l => {
            this.dynamicMedia[l].link = item.link
            this.dynamicMedia[l].overlay = item.overlay
          })
        })
      } else if (['bundle', 'group'].includes(buyRequest.type) && buyRequest.children?.length) {
        // For bundles with multiple children, we only want to show the images for the first child
        this.checkDynamicMedia(buyRequest.children[0])
      } else {
        buyRequest.children?.forEach(child => this.checkDynamicMedia(child))
      }
    },
  },

}

</script>
<style lang="scss">
.product-page {
  min-height: calc(100dvh - var(--header-height, 0px));
  padding-bottom: $size-l;

  .main-container img,
  .main-container-wide img {
    max-width: 100%;
  }

  @include mobile() {
    .bv-cv2-cleanslate .bv-core-container-38 .bv-action-bar button.bv-write-review {
      display: none !important;
    }
  }
}

// @todo refactor this into a property per BLOCK in the full section, not as an overall setting
.product.full-bleed-full {
  @include mobile() {
    .full-content {
      margin-left: -$space-s;
      margin-right: -$space-s;
    }
  }

  @include tablet() {
    .full-content {
      margin-left: -$space-m;
      margin-right: -$space-m;
    }
  }

  @include desktop() {
    .full-content {
      margin-left: -$space-xxl;
      margin-right: -$space-l;
    }
  }

  @include large-xl() {
    .full-content {
      margin-left: -$space-xxxxl;
      margin-right: -$space-xxxl;
    }
  }
}

.crumbs {
  padding-top: 20px;
}

@include xl() {
  .crumb-container {
    max-width: 1920px;
    padding-left: 72px;
    margin: 0 auto;
  }
}

@include all-desktop() {
  .crumbs {
    position: absolute;
    z-index: 2;
  }

  .product-page.hero {
    // Light breadcrumbs sit on the hero image. A soft dark backdrop keeps them readable on lighter photos, and
    // gives contrast checkers a background to use; padding is offset by margin so the text doesn't move
    .crumbs.light {
      padding: calc(20px + #{$space-xs}) $space-m $space-xs;
      margin: (-$space-xs) (-$space-m);
      background-image: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 75%);
    }

    .breadcrumbs .crumb {
      &.light {
        // Light text sits on the hero image, so a dark halo keeps it readable on lighter photos (WCAG 1.4.3)
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.9), 0 0 8px rgba(0, 0, 0, 0.6);

        a,
        span {
          color: $color-gray;
        }
      }

      &.dark {

        a,
        span {
          color: $color-black-light;
        }
      }

      span:not(.slash),
      a:hover {
        color: $color-white;
      }
    }
  }
}

.grid-main .main {
  img {
    max-width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.scroll-to-micropackage {
  font-weight: $weight-bold;
  font-size: $size-xs;
  color: $color-black-light;

  &:hover {
    padding-top: 13px;
    padding-bottom: 13px;
  }
}

.three-free-badge,
.five-for-five-badge,
.cart-ships-free-badge {
  display: flex;
  margin-top: $space-xs;
}

.three-free-content,
.five-for-five-content,
.cart-ships-free-content {
  padding: $space-xs;

  h4,
  h5 {
    margin-bottom: $space-xxxs;
  }
}

.five-for-five-content {
  .small {
    font-size: $size-xxs;
    margin-top: 5px;
    font-weight: $weight-bold;
  }
}

.main-container-wide.crumbs {
  padding-top: $size-l;
}

.divider {
  height: 1px;
  background-color: $color-gray;
  margin: $size-s 0;
}

// Giftcard
.giftcard-content {
  display: none;
  padding: $space-s;

  @include not-mobile() {
    display: block;
  }

  @media (min-width: $mobileBp + 1) and (max-width: 1328px) {
    margin: 0 $space-m;
  }
}

.gc-decription {
  margin-bottom: $space-l;
}

.gc-body {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.b-left {
  margin-right: $space-xs;
}

.b-right {
  .title {
    font-size: $size-s;
    margin-bottom: $space-xxxs;
  }

  .desc {
    font-size: $size-xs;
    margin-bottom: 0;
  }
}

.manta-ray-builder {
  height: 600px;
  width: 100%;
  position: relative;
}
</style>

<style lang="scss" scoped target="app">
@use 'Src/scss/variables.scss' as *;

.platform-ios,
.platform-android {
  .product {
    margin-top: $space-m;

    &:deep() {
      .full-width {
        padding: 0 $app-gap-default;
      }

      .media-mobile {
        margin-bottom: $app-gap-default;
      }

      .product-stars-container,
      .swatches-container {
        margin-bottom: $size-xxs;
      }

      .drawer-outer-container {
        &>.drawer-body {
          @include scrollable(x);
        }
      }

      .rhpa-footer .button:not(.decrement):not(.increment).loading-bar {
        z-index: 0;
      }

      .mobile-full .scroller-wrap {
        padding-left: 0;
      }
    }
  }
}

.pdp-bottom {
  display: flex;
  flex-direction: column;

  >div {
    order: 2;
  }
}
</style>
